import React, { useState } from "react";
import CustomInput from "../../components/CustomInput";
import Notification from "../../components/ui-elements/Notification";
import {
  createProductClass,
  deleteProductClassImage,
  updateProductClass,
  uploadProductClassImage,
} from "../../services/productClass";
import { IS_LOCAL_ENV } from "../../App";

const ProductClassForm = ({ handleClose, loadToParent, prevData }) => {
  const [imgFile, setImgFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [formData, setFormData] = useState({
    name: prevData?.name || "",
    code: prevData?.code || "",
    description: prevData?.description || "",
  });

  const onChangeSomeValue = (newVal, field, subfield) => {
    let temp = { ...formData };
    if (subfield) temp[field][subfield] = newVal;
    else temp[field] = newVal;
    setFormData(temp);
  };

  const handleFileChange = (e, type) => {
    const selectedFile = e.target.files[0]; // Obtén el primer archivo seleccionado
    if (selectedFile) {
      // Verifica si el archivo es un PDF
      if (selectedFile.type.startsWith("image/") && type == "mainImage") {
        setImgFile(selectedFile);
      }
      //else if (selectedFile.type === "application/pdf" && type == "pdf") {
      //   setPdfFile(selectedFile);
      //}
      else {
        Notification({
          title: "Operación inválida",
          text: "Por favor selecciona una imagen.",
          type: "Error",
        });
      }
    }
  };

  const validForm = () => {
    if (prevData) {
      return formData.name.trim() != "" && formData.code.trim() != "";
    } else
      return (
        formData.name.trim() != "" &&
        formData.code.trim() != "" &&
        imgFile != null
      );
  };

  const handleSubmit = () => {
    if (validForm()) {
      setUploading(true);
      const uploadData = async () => {
        try {
          let newImgId = null;
          if (imgFile != null) {
            //eliminar imagen anterior en caso exista
            if (prevData) await deleteProductClassImage(prevData.image.id);
            //cargar nueva imagen
            const resim = await uploadProductClassImage({
              alt: imgFile.name,
              file: imgFile,
            });
            newImgId = resim.id;
          }
          let data = formData;
          data.code = data.code.toUpperCase();
          if (newImgId != null) data.image = newImgId;

          const response = prevData
            ? await updateProductClass(prevData.id, formData)
            : await createProductClass(formData);
          Notification({
            title: "Operación completada",
            text: `Se ${prevData ? "actualizó" : "creó"} la clase de producto`,
            type: "Success",
          });
          if (prevData) loadToParent(response, prevData.id);
          else loadToParent(response);
          setUploading(false);
          handleClose();
        } catch (err) {
          IS_LOCAL_ENV && console.error(err);
          Notification({
            title: "Error",
            text: `Algo salió mal...`,
            type: "Error",
          });
          setUploading(false);
        }
      };
      uploadData();
    } else {
      Notification({
        title: "Operación inválida",
        text: "Datos incompletos",
        type: "Error",
      });
    }
  };

  return (
    <div className="flex flex-col md:p-4 p-2 items-center">
      <h3 className="modalTitle text-dark-green ">
        {prevData ? "Actualizar " : "Crear "}clase de producto
      </h3>
      <form className="w-full p-2 flex flex-wrap items-start">
        <CustomInput
          //customMaxW={"max-w-[300px]"}
          title="Nombre de clase"
          value={formData.name}
          onChange={(e) => onChangeSomeValue(e.target.value, "name")}
          placeholder="ej: Planta"
          inputType="text"
          required={true}
        />
        <CustomInput
          //customMaxW={"max-w-[300px]"}
          disabled={prevData ? true : false}
          title="Código(máx 5 caracteres)"
          value={formData.code}
          onChange={(e) => onChangeSomeValue(e.target.value, "code")}
          placeholder="ej: PLANT"
          inputType="text"
          required={true}
        />
        <CustomInput
          //customMaxW={"max-w-[400px]"}
          title="Descripción"
          value={formData.description}
          onChange={(e) => onChangeSomeValue(e.target.value, "description")}
          placeholder="some description..."
          inputType="textarea"
        />
        {/*imagen*/}
        <div className="my-2  px-4">
          <span className="font-poppins font-bold">
            {prevData ? "Reemplazar imagen" : "Cargar imagen *"}{" "}
          </span>
          <input
            className="font-poppins rounded-full text-nowrap border-accent-green border-[1px] flex flex-col w-full max-w-[300px] text-sm"
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "mainImage")}
          />
        </div>
        {/* <div className="mt-2 ml-4 font-poppins font-bold">
          <input
            type="checkbox"
            checked={formData.takesSupplies}
            onChange={(e) =>
              onChangeSomeValue(e.target.checked, "takesSupplies")
            }
            className=" rounded-[2px] checked:bg-accent-green focus:ring-transparent"
          />
          &nbsp;Requiere medicinas
        </div> */}
      </form>

      <button
        className={` w-fit my-2 text-base rounded-full py-2 px-4 text-white  transition-all duration-100 font-bold font-poppins ${
          uploading
            ? "bg-light-gray cursor-not-allowed"
            : "hover:bg-accent-green bg-dark-green"
        }`}
        disabled={uploading}
        type="submit"
        onClick={handleSubmit}
      >
        <div className="flex flex-row items-center">
          <span className="text-nowrap text-xl">Guardar</span>
        </div>
      </button>
    </div>
  );
};

export default ProductClassForm;
